import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as deLocale from 'date-fns/locale/de';
import * as enLocale from 'date-fns/locale/en';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {
  public start: Date = null;
  public end: Date = null;
  public options: DatepickerOptions = null;

  @Input()
  loadedStart: { day: number; month: number; year: number } = null;
  @Input()
  loadedEnd: { day: number; month: number; year: number } = null;

  @Output()
  onChange: EventEmitter<any> = new EventEmitter();

  constructor(translateService: TranslateService) {
    this.options = {
      minYear: 2017,
      maxYear: 2118,
      displayFormat: 'DD.MM.YYYY',
      barTitleFormat: 'MMMM YYYY',
      dayNamesFormat: 'dd',
      firstCalendarDay: 1, // 0 - Sunday, 1 - Monday
      locale: translateService.currentLang === 'de' ? deLocale : enLocale,
      minDate: new Date('2017-01-01'), // Minimal selectable date
      maxDate: new Date('2118-12-31'), // Maximal selectable date
      barTitleIfEmpty: '',
    };
  }

  ngOnInit() {
    this.start = this.loadedStart ? this.castToDate(this.loadedStart) : new Date();
    this.end = this.loadedEnd ? this.castToDate(this.loadedEnd) : new Date();
  }

  changeStart(value) {
    this.start = value;

    if (this.start > this.end) {
      this.end = this.start;
    }

    this.emitChanges();
  }

  changeEnd(value) {
    this.end = value;

    if (this.start > this.end) {
      this.end = this.start;
    }

    this.emitChanges();
  }

  emitChanges() {
    this.onChange.emit({
      beginDate: { day: this.start.getDate(), month: this.start.getMonth() + 1, year: this.start.getFullYear() },
      endDate: { day: this.end.getDate(), month: this.end.getMonth() + 1, year: this.end.getFullYear() },
    });
  }

  castToDate(dateObject: any) {
    const year = dateObject.year;
    let month = dateObject.month;
    let day = dateObject.day;

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return new Date(`${year}-${month}-${day}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.component.ts